import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import NotificationBox from '../../containers/form/NotificationBox'
import { LANGUAGES, LanguageCode, normalizeLanguage } from '../../i18n/languages'
import { saveLanguage } from '../../i18n/profileLanguage'
import { SettingsOption, SettingsSection } from './SettingsSection'

/** "Your language": the interface, word meanings and emails. Each language is listed in its own name. */
const LanguageSection = ({ id }: { id?: string }) => {
  const { t, i18n } = useTranslation()
  const current = normalizeLanguage(i18n.language)
  const [isUpdating, setIsUpdating] = useState(false)
  const [notify, setNotify] = useState({ label: '', isError: false })

  const clearNotify = () => setNotify({ label: '', isError: false })

  const choose = async (language: LanguageCode) => {
    if (language === current || isUpdating) return
    clearNotify()
    setIsUpdating(true)
    try {
      await saveLanguage(language)
      setNotify({ label: t('languageSettings.saved'), isError: false })
    } catch {
      setNotify({ label: t('languageSettings.saveError'), isError: true })
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <SettingsSection
      id={id}
      title={t('languageSettings.title')}
      note={`${t('languageSettings.note')} ${t('teacherLanguageNotice')}`}
    >
      <NotificationBox clearNotify={clearNotify} {...notify} />
      <div className='settings-options settings-options--grid'>
        {LANGUAGES.map(({ code, nativeName }) => (
          <SettingsOption
            key={code}
            type='radio'
            name='interface-language'
            label={nativeName}
            labelLang={code}
            checked={current === code}
            disabled={isUpdating}
            onChange={() => choose(code)}
          />
        ))}
      </div>
    </SettingsSection>
  )
}

export default LanguageSection
